import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FileText, Network } from "lucide-react";
import AdminShell from "@/components/admin/AdminShell";
import { HowItWorks } from "@/components/admin/HowItWorks";
import { TalentUpload } from "@/components/si/TalentUpload";
import { TalentPool } from "@/components/si/TalentPool";
import { ConnectionsUpload } from "@/components/connections/ConnectionsUpload";
import { ConnectionsList } from "@/components/connections/ConnectionsList";
import { SI, useSiMe } from "@/lib/sourcing";
import { cn } from "@/lib/utils";

const TABS = [["talent", "Talent (resumes)", FileText], ["connections", "Connections (contacts)", Network]];

export default function SITalent() {
  const me = useSiMe();
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") === "connections" ? "connections" : "talent";
  const [stamp, setStamp] = useState(0);
  const [cs, setCs] = useState(0);
  return (
    <AdminShell area="si" title="My Talent & Connections" subtitle="Your own candidates and your network in one place. Resumes feed every search; LinkedIn and email contacts power warm leads, decision makers and company data.">
      <div className="space-y-5" data-testid="si-talent-page">
        <Link to={SI} className="text-xs text-zinc-500 hover:text-[#D4AF37]" data-testid="si-talent-back">← All sourcing projects</Link>
        <HowItWorks id="use-connections" />
        <div className="grid gap-5 xl:grid-cols-2">
          <TalentUpload readOnly={me.readOnly} onDone={() => setStamp((s) => s + 1)} />
          <ConnectionsUpload readOnly={me.readOnly} onDone={() => { setCs((s) => s + 1); setSp({ tab: "connections" }); }} />
        </div>
        <div className="inline-flex rounded-full border border-[#27272A] bg-[#0f0f12] p-1" data-testid="si-talent-tabs">
          {TABS.map(([k, l, I]) => <button key={k} onClick={() => setSp(k === "talent" ? {} : { tab: k })} className={cn("inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 text-xs transition-colors", tab === k ? (k === "talent" ? "bg-[#D4AF37] font-semibold text-black" : "bg-cyan-400 font-semibold text-black") : "text-zinc-400 hover:text-zinc-100")} data-testid={`si-talent-tab-${k}`}><I className="h-3.5 w-3.5" />{l}</button>)}
        </div>
        {tab === "talent" ? <TalentPool stamp={stamp} readOnly={me.readOnly} /> : <ConnectionsList stamp={cs} />}
      </div>
    </AdminShell>
  );
}
